import { render } from "./Fridge.vue?vue&type=template&id=5a16c972&scoped=true"
import script from "./Fridge.vue?vue&type=script&lang=js"
export * from "./Fridge.vue?vue&type=script&lang=js"

import "./Fridge.vue?vue&type=style&index=0&id=5a16c972&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a16c972"]])

export default __exports__